import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'

import { generatePath, useNavigate } from 'react-router-dom'

import { Routes } from '../routes/routes'

import { useCurrentRoute } from './useCurrentRoute'
import { useAppConfig } from './useAppConfig'

export function useChangeLanguage() {
  const { route, location } = useCurrentRoute()
  const { routes } = useAppConfig()
  const { t } = useTranslation(['routes'])
  const navigate = useNavigate()

  const changeLanguage = useCallback(
    (lng: string) => {
      const newRoute = route?.key || Routes.Home
      const pathName = routes[newRoute] ? t(routes[newRoute]?.localizationKey || newRoute, { lng }) : route
      //TODO: remove below code of checkPreferredLang after detail analysis of history.replacestate() mehtod
      const queryParams = new URLSearchParams(location.search)
      queryParams.delete('checkPreferredLang')

      navigate(
        { pathname: generatePath(`/${lng}${pathName}`, route?.routeData?.params), search: queryParams.toString() },
        { state: location.state }
      )
    },
    [route, routes, t, navigate, location.search, location.state]
  )

  return {
    changeLanguage
  }
}
